module.exports = __webpack_public_path__ + "img/Veranza-2-min.3203c9ad.jpg";